export default __webpack_public_path__ + "static/media/kos.7b9936a9.jpg";